<template>
  <div>
    <v-card elevation="1" >
      <v-card-title>
        Cambio de precio por categoría
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="Categoria"
          label="Categoría del servicio"
          :items="Categories"
          item-value="id"
          item-text="Nombre"
        >
        </v-autocomplete>
        <v-radio-group
          v-model="type"
          row
        >
          <v-radio
            label="Aumento de precio"
            :value="1"
          ></v-radio>
          <v-radio
            label="Reducción de precio"
            :value="2"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          v-model="porcentaje"
          label="Porcentaje de incremento/decremento"
          @keypress="$pgsHelper.onlyNumber($event, porcentaje)"
        >
        </v-text-field>
      </v-card-text>
      <v-alert
        v-if="Categoria != '' && porcentaje != '' "
        outlined
        class="mx-2"
        :color="(type == 1)?'primary':'orange'"
      >
        <div class="text-h6">
          {{(type == 1)?'Aumento de precio':'Reducción de precio'}}
        </div>
        <div>
          El precio de la categoría
          {{$pgsHelper.getById(Categories,"id",Categoria).Nombre}}
          {{(type == 1)?'aumentara':'reduccira'}} un {{ porcentaje }}%
        </div>
      </v-alert>
      <v-card-text>
        <div class="text-right">
          <v-btn large @click="$emit('toggle',false);">Cancelar</v-btn>
          <v-btn style="margin-left: 6px;" color="success" large @click="savePrecios()" >Guardar</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>

</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "ProductoPrecioPorcentajeForm",
  components: {
    //customSelect
  },
  props: ["edit", "dataEdit"],
  data() {
    return {
      loader: true,
      Id: "",
      porcentaje:'',
      Categories:[],
      Categoria:'',
      type:1,
    };
  },
  methods: {
    savePrecios(){
      let updates = [];
      this.dataEdit.existenciaPrecio.forEach((update)=>{
        updates.push({Origen:update.Origen,Precio:Number(update.Price.PV)})
      })
      let data = {
        Producto:this.dataEdit.id,
        Updates:updates,
      }
        this.$swal({
        title: "¿Deseas editar el precio de este producto?",
        text: "Los cambios se veran reflejados inmediatamente",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar Precio",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //'ProShop-Productos-editarProducto'
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-updatePrecioProducto", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El precio de producto se edito correctamente",
              icon: "success",
            }).then(() => {
              this.$emit('toggle',false);
            });
          } else {
            this.$swal(
              "Error guardando Precios",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
  },
  computed: {
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.getCategories()
    this.loader=false
  },
};
</script>